import React from 'react'

export const DrawerChevronOpen = () => (
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 21L11 11L1 1" stroke="#000B3C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M11 21L21 11L11 1" stroke="#000B3C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)
